export const municipalities = ["Arlington", "Boston", "Cambridge", "Quincy", "Somerville", "Medford"];
export default municipalities;
